/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Walkthrough_P1_Content_Plus_ExclusiveInputs */

const en_subscription_walkthrough_p1_content_plus_exclusive = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Plus_ExclusiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Exclusive trees</span> only for Plus users</span>`)
};

const ar_subscription_walkthrough_p1_content_plus_exclusive = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Plus_ExclusiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"> <span style="[%2$s]">أشجار حصرية </span> لمستخدمي بلس فقط </span>`)
};

const de_subscription_walkthrough_p1_content_plus_exclusive = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Plus_ExclusiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Exklusive Bäume</span> nur für Plus-Benutzer</span>`)
};

const es_subscription_walkthrough_p1_content_plus_exclusive = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Plus_ExclusiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Árboles exclusivos</span> sólo para usuarios Plus</span>`)
};

const fr_subscription_walkthrough_p1_content_plus_exclusive = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Plus_ExclusiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Arbres exclusifs</span> réservés aux utilisateurs Plus</span>`)
};

const it_subscription_walkthrough_p1_content_plus_exclusive = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Plus_ExclusiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Alberi esclusivi</span> solo per gli utenti Plus</span>`)
};

const ja_subscription_walkthrough_p1_content_plus_exclusive = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Plus_ExclusiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Plusユーザー<span style="[%2$s]">限定樹種</span></span>`)
};

const ko_subscription_walkthrough_p1_content_plus_exclusive = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Plus_ExclusiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">오직 Plus 사용자를 위한 <span style="[%2$s]">전용 나무</span></span>`)
};

const pt_br_subscription_walkthrough_p1_content_plus_exclusive = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Plus_ExclusiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Árvores exclusivas</span> somente para usuários Plus</span>`)
};

const ru_subscription_walkthrough_p1_content_plus_exclusive = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Plus_ExclusiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Эксклюзивные растения</span> только для пользователей Plus</span>`)
};

const th_subscription_walkthrough_p1_content_plus_exclusive = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Plus_ExclusiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">ต้นไม้สุดพิเศษ</span>เฉพาะผู้ใช้ Plus เท่านั้น</span>`)
};

const tr_subscription_walkthrough_p1_content_plus_exclusive = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Plus_ExclusiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Sadece Plus kullanıcılarına<span style="[%2$s]">özel ağaçlar </span></span>`)
};

const zh_cn_subscription_walkthrough_p1_content_plus_exclusive = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Plus_ExclusiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">抢先体验<span style="[%2$s]"> Plus 独享树种</span></span>`)
};

const zh_tw_subscription_walkthrough_p1_content_plus_exclusive = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Plus_ExclusiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">搶先體驗<span style="[%2$s]"> Plus 獨享樹種</span></span>`)
};

/**
* | output |
* | --- |
* | "<span style=\"[%1$s]\"><span style=\"[%2$s]\">Exclusive trees</span> only for Plus users</span>" |
*
* @param {Subscription_Walkthrough_P1_Content_Plus_ExclusiveInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_walkthrough_p1_content_plus_exclusive = /** @type {((inputs?: Subscription_Walkthrough_P1_Content_Plus_ExclusiveInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Walkthrough_P1_Content_Plus_ExclusiveInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_walkthrough_p1_content_plus_exclusive(inputs)
	if (locale === "ar") return ar_subscription_walkthrough_p1_content_plus_exclusive(inputs)
	if (locale === "de") return de_subscription_walkthrough_p1_content_plus_exclusive(inputs)
	if (locale === "es") return es_subscription_walkthrough_p1_content_plus_exclusive(inputs)
	if (locale === "fr") return fr_subscription_walkthrough_p1_content_plus_exclusive(inputs)
	if (locale === "it") return it_subscription_walkthrough_p1_content_plus_exclusive(inputs)
	if (locale === "ja") return ja_subscription_walkthrough_p1_content_plus_exclusive(inputs)
	if (locale === "ko") return ko_subscription_walkthrough_p1_content_plus_exclusive(inputs)
	if (locale === "pt_br") return pt_br_subscription_walkthrough_p1_content_plus_exclusive(inputs)
	if (locale === "ru") return ru_subscription_walkthrough_p1_content_plus_exclusive(inputs)
	if (locale === "th") return th_subscription_walkthrough_p1_content_plus_exclusive(inputs)
	if (locale === "tr") return tr_subscription_walkthrough_p1_content_plus_exclusive(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_walkthrough_p1_content_plus_exclusive(inputs)
	return zh_tw_subscription_walkthrough_p1_content_plus_exclusive(inputs)
});